import { render, staticRenderFns } from "./UpdateStructurePopup.vue?vue&type=template&id=1c9ad256&scoped=true&"
import script from "./UpdateStructurePopup.vue?vue&type=script&lang=js&"
export * from "./UpdateStructurePopup.vue?vue&type=script&lang=js&"
import style0 from "./UpdateStructurePopup.vue?vue&type=style&index=0&id=1c9ad256&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9ad256",
  null
  
)

export default component.exports